export const API_PERFORMANCE_ROUTES = Object.freeze({
  FETCH_DATA: '/performance/:client',
  EXPORT_DATA: '/performance/export/:client',
  PERFORMANCE: '/performance',
  FIELDS: '/performance/fields',
  TOP_BOTTOM_ANALYSIS: 'performance/top-bottom-analysis',
  TOP_CREATIVE: '/performance/creative',
});
